import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight, Check } from "lucide-react";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get(`/services/${slug}`).then((r) => setService(r.data)).catch(() => setErr("Not found")); }, [slug]);
  if (err) return <div className="p-20 text-center pt-40">Service not found.</div>;
  if (!service) return <div className="p-20 text-center pt-40 text-[#6B665E]">Loading…</div>;
  return (
    <div data-testid={`service-detail-page-${service.slug}`} className="bg-[#F5EFE4]">
      <section className="relative h-[70vh] overflow-hidden">
        <img src={service.hero_image || service.image} alt={service.name} className="w-full h-full object-cover image-scale-in" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1815] via-[#1A1815]/40 to-[#1A1815]/20" />
        <div className="absolute inset-x-0 bottom-0">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-16">
            <p className="overline">Discipline</p>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-8xl mt-4 text-[#F5EFE4]">{service.name}</h1>
            <p className="text-[#F5EFE4]/80 max-w-xl mt-4">{service.tagline}</p>
          </div>
        </div>
      </section>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="overline">About the discipline</p>
          <p className="text-[#1A1815] mt-4 leading-relaxed text-lg font-light">{service.description}</p>
          <Link to={`/book?service=${service.slug}`} className="luxor-btn-primary mt-8" data-testid="detail-reserve-btn">Reserve this service <ArrowRight size={13} /></Link>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <p className="overline">Packages</p>
          <div className="mt-6 space-y-4">
            {service.packages.map((p) => {
              const u = (p.unit || "").trim();
              const isFrom = u.toLowerCase().startsWith("from");
              const isQuote = u.toLowerCase().startsWith("quote");
              const isComp = u.toLowerCase().startsWith("complimentary");
              const suffix = isFrom ? u.slice(4).trim().replace(/^·\s*/, "") : u;
              return (
                <div key={p.id} className="bg-white border border-[#E4D9C1] p-6 hover:border-[#C5A059] transition-colors" data-testid={`package-${p.id}`}>
                  <div className="flex justify-between items-baseline gap-4">
                    <h3 className="font-serif text-2xl">{p.name}</h3>
                    <div className="text-right">
                      {isQuote ? (
                        <>
                          <div className="font-serif text-3xl text-[#C5A059]">Quote</div>
                          <div className="text-[10px] uppercase tracking-[0.24em] text-[#6B665E]">on request</div>
                        </>
                      ) : isComp ? (
                        <>
                          <div className="font-serif text-2xl text-[#C5A059]">Complimentary</div>
                          <div className="text-[10px] uppercase tracking-[0.24em] text-[#6B665E]">for members</div>
                        </>
                      ) : (
                        <>
                          <div className="font-serif text-3xl text-[#C5A059]">
                            {isFrom && <span className="text-lg text-[#6B665E] mr-1">From</span>}£{p.price.toLocaleString()}
                          </div>
                          {suffix && <div className="text-[10px] uppercase tracking-[0.24em] text-[#6B665E]">{suffix}</div>}
                        </>
                      )}
                    </div>
                  </div>
                  <ul className="mt-4 space-y-1.5">
                    {p.features.map((f) => (<li key={f} className="text-sm text-[#4A453E] flex gap-2 items-center"><Check size={13} className="text-[#C5A059]" /> {f}</li>))}
                  </ul>
                  <Link to={`/book?service=${service.slug}&package=${p.id}`} className="mt-5 inline-block text-xs uppercase tracking-[0.24em] text-[#C5A059] hover:text-[#B08944]" data-testid={`package-book-${p.id}`}>Reserve · {p.name} →</Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
